import { useCallback } from 'react'

import { useHistory } from 'react-router-dom'
import { EDIT_PROFILE_URL } from './profile.places'

export const useEditProfile = () => {
  let history = useHistory()

  return useCallback(() => {
    history.push(EDIT_PROFILE_URL)
  }, [])
}
